import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";
import { apiPyAxios } from "../../api/axios";
import "./event-style.css";

/* Icons */
const ClockIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const LocationIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);
const RupeeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M6 3h12M6 8h12M6 13l8.5 8M6 13h3a4 4 0 0 0 0-8" />
  </svg>
);

const GridIcon = ({ active }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke={active ? "#fff" : "#999"}
    strokeWidth="2"
  >
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </svg>
);

const ListIcon = ({ active }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke={active ? "#fff" : "#999"}
    strokeWidth="2"
  >
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

/* Grid Card */

const GridCard = ({ event, openRegisterModal }) => (
  <div className="col-12 col-md-6 col-lg-4">
    <div className="event-card">
      <div className="event-image-wrapper">
        <img src={event.image} alt={event.name} className="event-card-image" />
        {(event.day || event.month) && (
          <div className="event-date-badge">
            <span className="event-date-day">{event.day}</span>
            <span className="event-date-month">{event.month}</span>
          </div>
        )}
      </div>
      <div className="event-card-body">
        <h6 className="event-card-title">{event.name}</h6>
        <div className="event-meta-row">
          <span className="event-meta-icon">
            <ClockIcon />
          </span>
          <span className="event-meta-text">
            {event.effective_date} | {event.show_time}
          </span>
        </div>
        <div className="event-meta-row">
          <span className="event-meta-icon">
            <LocationIcon />
          </span>
          <span className="event-meta-text">{event.location}</span>
        </div>
        <div className="event-meta-row">
          <span className="event-meta-icon">
            <RupeeIcon />
          </span>

          <span className="event-meta-text">
            <strong>₹{event.price_per_person}</strong> per person
          </span>
        </div>
        <button
          onClick={() => openRegisterModal(event.id)}
          className={
            // event.registered ? "event-btn-registered" : "event-btn-register"
            "event-btn-register"
          }
        >
          {/* {event.registered ? "Already Registered" : "Register Now"} */}
          Register Now
        </button>
      </div>
    </div>
  </div>
);

/* List Card */
const ListRow = ({ event, openRegisterModal }) => (
  <div className="event-list-card mb-3">
    <div className="d-flex align-items-center gap-3 flex-grow-1">
      <img src={event.image} alt={event.name} className="event-list-image" />
      <div className="flex-grow-1">
        <h6 className="event-list-title">{event.name}</h6>
        <div className="event-meta-row">
          <span className="event-meta-icon">
            <ClockIcon />
          </span>
          <span className="event-meta-text">
            {event.effective_date} | {event.show_time}
          </span>
        </div>
        <div className="event-meta-row">
          <span className="event-meta-icon">
            <LocationIcon />
          </span>
          <span className="event-meta-text">{event.location}</span>
        </div>
        <div className="event-meta-row">
          <span className="event-meta-icon">
            <RupeeIcon />
          </span>
          <span className="event-meta-text">
            <strong>₹{event.price_per_person}</strong> per person
          </span>
        </div>
      </div>
    </div>
    <div className="event-list-btn-wrap">
      <button
        onClick={() => openRegisterModal(event.id)}
        className={
          // event.registered ? "event-btn-registered" : "event-btn-register"
          "event-btn-register"
        }
      >
        {/* {event.registered ? "Already Registered" : "Register Now"} */}
        Register Now
      </button>
    </div>
  </div>
);

export default function EventsPage({ language = "en" }) {
  const [activeTab, setActiveTab] = useState("events");
  const [viewMode, setViewMode] = useState("grid");
  const [lgShow, setLgShow] = useState(false);

  const [eventsData, setEventData] = useState([]);
  const [formName, setFormName] = useState("");
  const [formEmail, setFormEmail] = useState("");
  const [formPhone, setFormPhone] = useState("");
  const [formPersons, setFormPersons] = useState(1);
  const [selectedShowId, setSelectedShowId] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const textContent = {
    en: {
      pageTitle: "Events",
      homePage: "Home",
    },
    hi: {
      pageTitle: "कार्यक्रम",
      homePage: "मुख्य पृष्ठ",
    },
  };

  const fetchEvents = async () => {
    try {
      const params = {
        active: true,
      };

      const response = await apiPyAxios.get("shows/", { params });

      const raw = response.data.results || [];

      const enhanced = raw.map((event) => {
        let dateStrForLogic = null;

        if (event.show_type === "single" && event.show_date) {
          dateStrForLogic = event.show_date;
        } else if (event.show_type === "range" && event.start_date) {
          dateStrForLogic = event.start_date;
        } else if (event.show_type === "daily") {
          const today = new Date();
          const yyyy = today.getFullYear();
          const mm = String(today.getMonth() + 1).padStart(2, "0");
          const dd = String(today.getDate()).padStart(2, "0");
          dateStrForLogic = `${yyyy}-${mm}-${dd}`;
        }

        if (!dateStrForLogic) {
          return {
            ...event,
            day: "",
            month: "",
            effective_date: "",
          };
        }

        const date = new Date(dateStrForLogic);

        const day = String(date.getDate()).padStart(2, "0");
        const month = date
          .toLocaleString("en-US", { month: "short" })
          .toUpperCase();

        const effective_date = dateStrForLogic;

        return {
          ...event,
          day,
          month,
          effective_date,
        };
      });

      setEventData(enhanced);
    } catch (err) {
      console.error("Error fetching events:", err);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const openRegisterModal = (showId) => {
    setSelectedShowId(showId);
    setLgShow(true);
  };

  const isValidPhone = (value) => /^\d{10}$/.test(value);

  const validateForm = () => {
    const errors = {};

    if (!formName.trim()) errors.name = "Name is required";
    if (!formEmail.trim()) errors.email = "Email is required";
    if (!formPhone.trim()) errors.phone = "Mobile number is required";
    else if (!isValidPhone(formPhone))
      errors.phone = "Enter a valid 10-digit number";

    if (!formPersons || Number(formPersons) < 1) {
      errors.persons = "Person quantity must be at least 1";
    }

    if (!selectedShowId) {
      errors.show = "Please select an event to book";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmitBooking = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setSubmitting(true);

      const payload = {
        show: selectedShowId,
        user_email: formEmail,
        no_of_persons: Number(formPersons),
        phone_number: formPhone,
      };

      const res = await apiPyAxios.post("bookings/", payload);

      toast.success("Registration submitted successfully!");

      setFormName("");
      setFormEmail("");
      setFormPhone("");
      setFormPersons(1);
      setFormErrors({});
      setSelectedShowId(null);
      setLgShow(false);
      fetchEvents();
    } catch (err) {
      console.error("Error creating booking:", err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div
        className="inner-pages-head"
        style={{
          backgroundImage: `url('images/about-header-bg.jpg')`,
        }}
      >
        <div className="container">
          <div className="title_and_breadcrumbs">
            <h1>{textContent[language].pageTitle}</h1>
            <ul>
              <li>
                <Link to="/">{textContent[language].homePage}</Link>
              </li>
              <span></span>
              <li>{textContent[language].pageTitle}</li>
            </ul>
          </div>
          <div className="banner-logo">
            <img src="images/mahabharat-logo.svg" alt="" />
          </div>
        </div>
      </div>

      <section className="mt-5 mb-5">
        <div className="container event-page-wrapper">
          <div className="event-top-nav">
            <div className="d-flex align-items-center gap-2">
              <button
                className={
                  activeTab === "events"
                    ? "event-tab-active"
                    : "event-tab-inactive"
                }
                onClick={() => setActiveTab("events")}
              >
                Upcoming Events
              </button>
            </div>
            <div className="d-flex align-items-center gap-2">
              <button
                className={
                  viewMode === "grid"
                    ? "event-view-btn-active"
                    : "event-view-btn"
                }
                onClick={() => setViewMode("grid")}
              >
                <GridIcon active={viewMode === "grid"} />
              </button>
              <button
                className={
                  viewMode === "list"
                    ? "event-view-btn-active"
                    : "event-view-btn"
                }
                onClick={() => setViewMode("list")}
              >
                <ListIcon active={viewMode === "list"} />
              </button>
            </div>
          </div>

          <div className="event-content-wrapper">
            {viewMode === "grid" ? (
              <div className="row g-4">
                {eventsData.map((event) => (
                  <GridCard
                    key={event.id}
                    event={event}
                    openRegisterModal={openRegisterModal}
                  />
                ))}
              </div>
            ) : (
              <div>
                {eventsData.map((event) => (
                  <ListRow
                    key={event.id}
                    event={event}
                    openRegisterModal={openRegisterModal}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </section>

      <Modal
        size="lg"
        show={lgShow}
        onHide={() => {
          setLgShow(false);
          setFormErrors({});
        }}
        centered
        className="event-register-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Event Registration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmitBooking}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Your Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter full name"
                  value={formName}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormName(value);

                    setFormErrors((prev) => {
                      const next = { ...prev };
                      if (!value.trim()) {
                        next.name = "Full name is required";
                      } else {
                        delete next.name;
                      }
                      return next;
                    });
                  }}
                />
                {formErrors.name && (
                  <small className="text-danger">{formErrors.name}</small>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Email Address</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter email"
                  value={formEmail}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormEmail(value);

                    setFormErrors((prev) => {
                      const next = { ...prev };
                      if (!value.trim()) {
                        next.email = "Email is required";
                      } else {
                        delete next.email;
                      }
                      return next;
                    });
                  }}
                />
                {formErrors.email && (
                  <small className="text-danger">{formErrors.email}</small>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Phone Number</label>
                <input
                  type="tel"
                  className="form-control"
                  placeholder="Enter phone number"
                  value={formPhone}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormPhone(value);
                    setFormErrors((prev) => {
                      const next = { ...prev };
                      if (!value.trim()) {
                        next.phone = "Mobile number is required";
                      } else if (!isValidPhone(value)) {
                        next.phone = "Enter a valid 10-digit number";
                      } else {
                        delete next.phone;
                      }
                      return next;
                    });
                  }}
                />
                {formErrors.phone && (
                  <small className="text-danger">{formErrors.phone}</small>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Number of Guests</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter number of guests"
                  min="1"
                  value={formPersons}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormPersons(value);

                    setFormErrors((prev) => {
                      const next = { ...prev };
                      if (!value || Number(value) < 1) {
                        next.persons = "Number of guests must be at least 1";
                      } else {
                        delete next.persons;
                      }
                      return next;
                    });
                  }}
                />
                {formErrors.persons && (
                  <small className="text-danger">{formErrors.persons}</small>
                )}
              </div>
              {formErrors.show && (
                <div className="col-12">
                  <small className="text-danger">{formErrors.show}</small>
                </div>
              )}
              <div className="col-12 mt-2">
                <button
                  type="submit"
                  className="event-submit-btn"
                  disabled={submitting}
                >
                  {submitting ? "Submitting..." : "Submit Registration"}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>

    </>
  );
}
